namespace ui
{
	export namespace Form
	{

		export interface ICheckableLabel
		{
			value?: string;
			title?: string;
			descriptor?: IBasicInputDescriptor;
		}

		export abstract class Checkable
			extends Input
		{
			public readonly	Name:			string|undefined;

			protected	m_Base:		JQuery<HTMLElement>;

			private		m_Title:	JQuery<HTMLElement>;

			public constructor( label: ICheckableLabel, type: string, inputtype: InputValueTypes, inline?: boolean )
			{
				super( label.value || '', label.descriptor || {}, type, inputtype );

				if ( this.Descriptor.name )
				{
					this.Name	= this.Descriptor.name;
				}

				this.m_Base		= ui.$$.label().addClass( type + ( inline ? '-inline' : '' ) ).append( this.m_Root );
				this.m_Title	= ui.$$.span().text( label.title || '' ).appendTo( this.m_Base );
			}

			public Initialize(): void
			{
				super.Initialize();

				this.m_Root.removeClass( 'form-control' );
			}

			public Title( title?: string ): string|Checkable
			{
				if ( title )
				{
					this.m_Title.text( title );

					return this;
				}

				return this.m_Title.text();
			}

			/*
				? Macht es Sinn, dass man sich das input-Element direkt holen kann
				? oder sollte man das Base-div-Element lieber zurückgeben
			*/
			public Root(): JQuery<HTMLElement>
			{
				return this.Base();
			}

		}

		export class Checkbox
			extends Checkable
		{

			public constructor( label: ICheckableLabel, inline?: boolean )
			{
				super( label, 'checkbox', InputValueTypes.BOOL, inline );
			}

			public isChecked(): boolean
			{
				return this.m_Root.prop( 'checked' );
			}

			public value( checked: boolean|0|100|null ): Checkbox
			{
				const isChecked = checked === true || checked === 100;
				this.m_Root.prop( 'checked', isChecked === true );

				return this;
			}

			public val(): boolean
			{
				return this.isChecked();
			}

		}

		export interface ISwitchDescriptor extends IBasicInputDescriptor
		{
			round?: boolean;
		}

		export class Switch
			extends BasicInputField<HTMLElement, ISwitchDescriptor>
		{

			public readonly	Default:					boolean;

			protected	m_Static:					boolean;

			private 	m_Needle:					JQuery<HTMLElement>;
			private		m_Round:					boolean;
			private		m_IsFormControl:	boolean;

			private	m_Label:	JQuery<HTMLElement>;
			private	m_Title:	JQuery<HTMLElement>;

			public constructor( label: ICheckableLabel )
			{
				super( 'switch', label.descriptor || {}, InputValueTypes.BOOL );

				const desc = label.descriptor as ISwitchDescriptor;

				this.m_Static					= false;
				this.m_IsFormControl	= !( desc.control === false );
				this.Default					= label.value ? true : false;
				this.m_Round					= false;

				this.m_Base.addClass( 'switch' );
				this.m_Label	= $( document.createElement( 'label' ) ).append( this.m_Root ).addClass( 'control-label col-xs-12' ).appendTo( this.m_Base );
				this.m_Title	= ui.$$.span().css( 'line-height', '1.7100021' ).text( label.title || '' ).appendTo( this.m_Label );

				this.m_Needle = new ui.base.BaseHTMLElement( 'switch-needle' ).Root();

				this.Initialize();
			}

			public reset(): void
			{

				if (  this.m_Root.attr( 'data-checked' ) === ( this.Default ? 'true' : 'false' ) )
				{
					const tmpStatic	= this.m_Static;
					this.m_Static	= false;

					this.switch();

					this.m_Static	= tmpStatic;
				}
			}

			public Title( title?: string ): string|Switch
			{
				if ( title )
				{
					this.m_Title.text( title );

					return this;
				}

				return this.m_Title.text();
			}

			public switch(): void
			{
				if ( this.m_Static ) {
					return;
				}

				const sb = this.m_Root;
				const sn = this.m_Needle;

				if ( sb.attr( 'data-checked' ) === 'true' )
				{
					sb.attr( 'data-checked', 'false' );
					sn.animate( { left: '-2px' }, 250 );
				}
				else
				{
					sb.attr( 'data-checked', 'true' );
					sn.animate( { left: ( ( sb.width() || 40 ) - ( ( sn.width() || 22 ) - 2 ) ) + 'px' }, 250 );
				}
			}

			public Initialize(): void
			{
				super.Initialize();

				this.m_Needle.appendTo( this.m_Root );

				this.m_Root.removeClass();

				this.m_Root.attr( 'data-checked', 'false' );

				this.m_Root.on( 'click', () => { this.switch(); } );

				if ( this.Descriptor.round )
				{
					this.m_Root.css( 'border-radius', '14px' );
					this.m_Needle.css( 'border-radius', '14px' );
				}
			}

			public Static( is_static_now: boolean ): void
			{
				this.m_Static	= is_static_now;
			}

			public CheckIfValid(): boolean
			{
				return true;
			}

			public val(): boolean
			{
				return this.m_Root.attr( 'data-checked' ) === 'true';
			}

			public value( value: boolean|null ): Switch
			{
				this.m_Root.attr( 'data-checked', value ? 'true' : 'false' );

				return this;
			}

		}

		export class Radio
			extends Checkable
		{

			public constructor( label: ICheckableLabel, inline?: boolean )
			{
				super( label, 'radio', InputValueTypes.STRING, inline );
			}

			public isChecked(): boolean
			{
				return this.m_Root.prop( 'checked' );
			}

			public value( checked: boolean|null ): Radio
			{
				this.m_Root.prop( 'checked', checked );

				return this;
			}

			public val( ignore: boolean = false ): string|null
			{
				if ( ignore ) {
					return this.m_Root.val() as string;
				}

				return this.isChecked() ? this.m_Root.val() as string : null;
			}

		}

		export interface IRadioGroupDescriptor
			extends IBasicInputDescriptor
		{
			radioButtons: ICheckableLabel[];
			value?: string|null;
			inline?:	number;
		}

		export class RadioGroup
			extends BasicInputField<HTMLElement, IRadioGroupDescriptor>
		{
			private		m_Radio: Radio[];

			public constructor( descriptor: IRadioGroupDescriptor )
			{
				super( 'div', descriptor, InputValueTypes.STRING );

				this.m_Radio	= new Array<Radio>();

				for ( const name in descriptor.radioButtons )
				{
					this.add( descriptor.radioButtons[ name ] );
				}
			}

			public CheckedRadio(): Radio|null
			{
				for ( const i in this.m_Radio )
				{
					if ( this.m_Radio[ i ].isChecked() ) { return this.m_Radio[ i ]; }
				}

				return null;
			}

			public reset(): void
			{
				this.value( this.Default );
			}

			public value( val: string|null ): RadioGroup
			{
				this.m_Radio.forEach( (radio) => radio.value( radio.val() === val ) );

				return this;
			}

			public val(): string|null
			{
				for ( const i in this.m_Radio )
				{
					if ( this.m_Radio[ i ].isChecked() )
					{
						return this.m_Radio[ i ].val();
					}
				}

				return null;
			}

			public clear(): void
			{
				this.m_Root.empty();
				this.m_Radio	= new Array();
			}

			public add( radio: ICheckableLabel ): void
			{
				const desc = radio.descriptor || {};

				desc.name = this.Descriptor.name;

				radio.descriptor = desc;

				const inline: boolean = this.Descriptor.inline !== undefined && this.Descriptor.inline > 0;

				this.m_Radio.push( new Radio( radio, inline ) );
			}

			public Radios(): Radio[]
			{
				return this.m_Radio;
			}

			public Initialize(): void
			{
				super.Initialize();

				if ( this.Descriptor.inline !== undefined )
				{
					this.m_Radio.forEach( (radio) => radio.Base().css( 'width', ( 100.0 / clamp( this.Descriptor.inline || 1, 1, 6 ) ) + "%" ) );

					this.m_Root.addClass( 'center-flex' );
				}

				this.m_Root.removeClass( 'form-control' );

				if ( this.Descriptor.value )
				{
					this.m_Radio.forEach( (radio) => radio.value( radio.val(true) === this.Descriptor.value ) );
				}
			}

			public rebuild( root: ui.base.BaseHTMLElement<HTMLElement>|JQuery<HTMLElement> ): RadioGroup
			{
				this.m_Root.empty();

				this.m_Radio.forEach( (radio) => radio.rebuild( this.m_Root ) );

				super.rebuild( root );

				return this;
			}
		}

		export interface ICheckboxGroupLabels
		{
			name: string;
			title?: string;
			descriptor?: IBasicInputDescriptor;
		}

		export interface ICheckboxGroupDescriptor
			extends IBasicInputDescriptor
		{
			checkboxes: ICheckboxGroupLabels[];
			value?: string[]|null;
			inline?: number;
		}

		export class CheckboxGroup
			extends ui.Form.BasicInputField<HTMLElement, ICheckboxGroupDescriptor>
		{
			public readonly	Default:		string[];

			private		m_Checkboxes: Checkbox[];

			public constructor( descriptor: ICheckboxGroupDescriptor )
			{
				super( 'div', descriptor, InputValueTypes.ARRAY );

				this.m_Checkboxes	= new Array<Checkbox>();

				const inline: boolean = descriptor.inline !== undefined && descriptor.inline > 0;
				descriptor.checkboxes.forEach( (cb) => this.add( cb ) );

				this.Default	= descriptor.value || [];
			}

			public CheckedBoxes(): Checkbox[]
			{
				const list: Checkbox[] = new Array<Checkbox>();

				this.m_Checkboxes.forEach( (checkbox) => { if ( checkbox.isChecked() ) { list.push( checkbox ); } } );

				return list;
			}

			public Initialize(): void
			{
				super.Initialize();

				if ( this.Descriptor.inline !== undefined )
				{
					this.m_Checkboxes.forEach( (checkbox) => checkbox.Base().css( 'width', ( 100.0 / clamp( this.Descriptor.inline || 2, 2, 6 ) ) + "%" ) );

					this.m_Root.addClass( 'center-flex' );
				}

				this.m_Root.removeClass( 'form-control' );

				if ( this.Descriptor.value )
				{
					this.Descriptor.value.forEach(
						(value) =>
						{
							const box = this.m_Checkboxes.find( (b) => b.Name === value );

							if ( box ) { box.value( true ); }
						}
					);
				}
			}

			public reset(): void
			{
				this.value( this.Default );
			}

			public clear(): void
			{
				this.m_Root.empty();
				this.m_Checkboxes	= new Array();
			}

			public add( cb: ICheckboxGroupLabels ): void
			{
				cb.descriptor				= cb.descriptor || {};

				cb.descriptor.name	=	this.Descriptor.name +
															( this.Descriptor.name && !this.Descriptor.name.endsWith( '.' ) ? '.' : '' ) +
															cb.name;

				this.m_Checkboxes.push( new Checkbox( cb, this.Descriptor.inline !== undefined && this.Descriptor.inline > 1 ) );
			}

			public value( vals: string[]|null ): CheckboxGroup
			{
				this.m_Checkboxes.forEach( (box) => box.value( false ) );
				if ( vals )
				{
					vals.forEach(( val ) =>
					{
						const radio = this.m_Checkboxes.find( (predicate) => predicate.Name === val );

						if ( radio ) { radio.value( true ); }
					});
				}

				return this;
			}

			public val(): string[]
			{
				const vals: string[] = new Array<string>();

				for ( const i in this.m_Checkboxes )
				{
					const box = this.m_Checkboxes[ i ];

					if ( box.isChecked() && box.Name )
					{
						vals.push( box.Name );
					}
				}

				return vals;
			}

			public Checkboxes(): Checkbox[]
			{
				return this.m_Checkboxes;
			}

			public rebuild( root: ui.base.BaseHTMLElement<HTMLElement>|JQuery<HTMLElement> ): CheckboxGroup
			{
				this.m_Root.empty();

				super.rebuild( root );

				this.m_Checkboxes.forEach( (checkbox) => checkbox.rebuild( this.m_Root ) );

				return this;
			}
		}

	}
}
